import { useEffect, useRef, useState } from 'react'

interface UseVideoProgressProps {
  videoUrl?: string
  duration?: number
}

export const useVideoProgress = ({ videoUrl, duration }: UseVideoProgressProps) => {
  const videoRef = useRef<HTMLVideoElement>(null)
  const [progress, setProgress] = useState(0)

  useEffect(() => {
    let animationFrameId: number
    const videoElement = videoRef.current

    const updateProgress = () => {
      if (videoRef.current && videoRef.current.readyState >= 1) {
        const videoDuration = duration || videoRef.current.duration
        const newProgress = (videoRef.current.currentTime / videoDuration) * 100
        setProgress(newProgress)
      }
      animationFrameId = requestAnimationFrame(updateProgress)
    }

    const startUpdatingProgress = () => {
      if (videoRef.current) {
        animationFrameId = requestAnimationFrame(updateProgress)
      }
    }

    if (videoRef.current) {
      if (videoRef.current.readyState >= 1) {
        startUpdatingProgress()
      } else {
        videoRef.current.addEventListener('loadedmetadata', startUpdatingProgress)
      }
    }

    return () => {
      videoElement?.removeEventListener('loadedmetadata', startUpdatingProgress)
      cancelAnimationFrame(animationFrameId)
    }
  }, [videoUrl, duration])

  return {
    videoRef,
    progress,
  }
}
